import { clsx } from "clsx";
import CloseIcon from "../../icons/close.svg";

function ConfirmAction(props) {
	const style = {
		reason: "m-2",
		button: "py-1 px-4 font-bold text-slate-100 rounded-full cursor-pointer",
	};

	const actionsToDisplayReasons = ["delRtp", "moveRip"];

	const type = props.action.type;
	let confirmMsg = "";
	let confirmBtn = "";
	let reasonTxt = "";
	let confirmBtnStyle = "bg-red-500 hover:bg-red-700";
	let cancelBtnStyle = "bg-zinc-400 hover:bg-zinc-600";
	switch (type) {
		case "delRtp":
			confirmMsg = "Are you sure you want to delete:";
			confirmBtn = "Delete";
			reasonTxt = props.action.data.reason;
			confirmBtnStyle = "bg-red-500 hover:bg-red-700";
			cancelBtnStyle = "bg-green-500 hover:bg-green-700";
			break;
		case "moveRip":
			confirmMsg = "Do you want to move this Reason to a Reason-in-Play?";
			confirmBtn = "Begin Bout";
			reasonTxt = props.action.data.reason;
			confirmBtnStyle = "bg-blue-500 hover:bg-blue-700";
			break;
		case "moveCG":
			confirmMsg = "Do you want to move the Reason-in-Play to Common Ground?";
			confirmBtn = "Common Ground";
			confirmBtnStyle = "bg-green-500 hover:bg-green-700";
			break;
		case "moveDS":
			confirmMsg = "Do you want to end this bout?";
			confirmBtn = "End Bout";
			break;
		case "moveCG-Rip":
			confirmMsg = "Do you want to move this Common Ground back in Play?";
			confirmBtn = "Reason-in-Play";
			reasonTxt = props.action.data.reason;
			confirmBtnStyle = "bg-green-500 hover:bg-green-700";
			break;
		case "exitGame":
			confirmMsg =
				props.action.role === "referee"
					? "Are you sure you want to end this game?"
					: "Are you sure you want to leave this game?";
			confirmBtn = props.action.role === "referee" ? "End Game" : "Exit Game";
			break;
		default:
			confirmMsg = "Are you sure you want to perform this action";
			confirmBtn = "Confirm";
	}

	function handleAction() {
		switch (type) {
			case "delRtp":
				props.deleteReason(props.action.data);
				break;
			case "moveRip":
				props.moveToReasonInPlay(props.action.data.playerId, props.action.data.reasonId);
				break;
			case "moveCG":
				props.handleMoveRIPToCommonGround();
				break;
			case "moveDS":
				props.handleMoveRIPToDissensus();
				break;
			case "moveCG-Rip":
				props.handleMoveCommonGroundToReasonInPlay(props.action.data.id);
				break;
			case "exitGame":
				props.handleExitGame(props.action.role);
				break;
			default:
				confirmMsg = "Are you sure you want to perform this action";
				confirmBtn = "Confirm";
		}
		props.closeModal();
	}

	return (
		<div className="fixed top-1/2 left-1/2 -translate-1/2 h-6/10 w-[95%] lg:h-3/10 lg:w-4/10 p-2 text-center bg-slate-50 border-2 border-blue-400 rounded-lg">
			<div
				className="absolute top-2.5 right-2.5 p-1 border-2 border-zinc-700 bg-zinc-200 rounded-full cursor-pointer"
				onClick={props.closeModal}>
				<CloseIcon className="w-3.75" />
			</div>
			<div className="flex flex-col justify-around h-full">
				<div className="font-bold">{confirmMsg}</div>
				{reasonTxt ? (
					<>
						<div className={style.reason}>{reasonTxt}</div>
					</>
				) : null}
				<div className="flex flex-row justify-center gap-8">
					<button
						aria-label={confirmBtn}
						className={clsx(style.button, confirmBtnStyle)}
						onClick={() => handleAction()}>
						{confirmBtn}
					</button>
					<button aria-label="Cancel" className={clsx(style.button, cancelBtnStyle)} onClick={() => props.closeModal()}>
						Cancel
					</button>
				</div>
			</div>
		</div>
	);
}

export default ConfirmAction;
